import { render, staticRenderFns } from "./NumberQuestion.vue?vue&type=template&id=2e61b870"
import script from "./NumberQuestion.vue?vue&type=script&lang=js"
export * from "./NumberQuestion.vue?vue&type=script&lang=js"
import style0 from "./NumberQuestion.vue?vue&type=style&index=0&id=2e61b870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports